import { get } from "@insite/client-framework/Services/ApiService";

export interface ContentModel {
    exportFieldName: string;
    id: string;
    ootbFieldName?: string;
    isDefault?: boolean;
}

export interface  PIMAttributesApiResultModel {
    PIMAttributesList: ContentModel[];
    loading: boolean;
}

const url = "/api/v2/PIMExport/GetPIMExportFields";

export async function getPIMAttributesAPI(parameter:string) {
    const response = await get<PIMAttributesApiResultModel>(`${url}?productType=${parameter}`);
    return response;
}

